// AUTO-GENERATED by @policystack/vite — do not edit.
import type { ScannedCollectionKeys } from "@policystack/sdk";

export const dataCollected: Record<keyof ScannedCollectionKeys & string, string[]> = {};
export const thirdParties: { name: string; purpose: string; policyUrl: string }[] = [];
export const cookies: { essential: true; [key: string]: boolean } = {"essential":true};
export const sharing: { key: string; recipient: string }[] = [];

declare module "@policystack/sdk" {
	interface ScannedCollectionKeys {
	}
	interface ScannedCookieKeys {
		"essential": true;
	}
	interface ScannedSharingKeys {
	}
}
